var map = {
	"./icon-account.svg": "ec32",
	"./icon-activities.svg": "0184",
	"./icon-arrow-right.svg": "b7a0",
	"./icon-calendar.svg": "e06d",
	"./icon-captcha-slider.svg": "bf8f",
	"./icon-captcha-verified.svg": "2db5",
	"./icon-choose-image.svg": "8845",
	"./icon-copy-gray.svg": "e452",
	"./icon-copy.svg": "fbab",
	"./icon-coupon-applied.svg": "8285",
	"./icon-coupon.svg": "7ba3",
	"./icon-discount-coupon.svg": "313f",
	"./icon-discount.svg": "71a4",
	"./icon-email-failed.svg": "e644",
	"./icon-email-success.svg": "c4d1",
	"./icon-email.svg": "129e",
	"./icon-eye.svg": "0269",
	"./icon-face_id.svg": "c7aa2",
	"./icon-fingerprint.svg": "ee09",
	"./icon-google-colors.svg": "4068",
	"./icon-headphone.svg": "a067",
	"./icon-home.svg": "43f5",
	"./icon-logout-red.svg": "9869",
	"./icon-menu-chat.svg": "5960",
	"./icon-menu-faq.svg": "939a",
	"./icon-menu-fx-alert.svg": "cc34",
	"./icon-menu-news-feed.svg": "3f74",
	"./icon-menu-notification.svg": "d8b7",
	"./icon-menu-privacy-policy.svg": "a7b6",
	"./icon-menu-tnc.svg": "2a5e",
	"./icon-menu-user.svg": "bf97",
	"./icon-money-send.svg": "4746",
	"./icon-msg.svg": "3ad7",
	"./icon-notif-dot.svg": "8220",
	"./icon-notif.svg": "4c2c",
	"./icon-notification.svg": "7cac",
	"./icon-pencil.svg": "16c1",
	"./icon-recipients-white.svg": "7103",
	"./icon-recipients.svg": "1812",
	"./icon-searchbar.svg": "8bf3",
	"./icon-send.svg": "6835",
	"./icon-setting-biometric.svg": "6727",
	"./icon-setting-dark-mode.svg": "f5bd",
	"./icon-setting-face-id.svg": "d081",
	"./icon-singpass.svg": "c92c",
	"./icon-success.svg": "b79e",
	"./icon-take-picture.svg": "8beb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7dd";